export const translations = {
  de: {
    nav: {
      home: "Home",
      collection: "Kollektion",
      configurator: "Konfigurieren",
      about: "Über uns",
      contact: "Kontakt",
    },
    hero: {
      kicker: "SWISS MADE. YOUR DESIGN.",
      title: "BUILD YOUR SOMMET",
      subtitle: "Gestalte deine persönliche SOMMET-Uhr. Wähle jedes Detail selbst und erschaffe einen Zeitmesser, der perfekt zu dir passt.",
      cta: "Jetzt konfigurieren",
      cta2: "Kollektion entdecken",
    },
    advantages: {
      kicker: "Warum SOMMET",
      title: "Präzision aus Zürich",
      items: [
        { title: "Individuell gefertigt", desc: "Von dir gestaltet — für dich gebaut in unserer Schweizer Manufaktur." },
        { title: "Premium-Qualität", desc: "Gehäuse aus 316L-Edelstahl, präzisionsgefräst und poliert." },
        { title: "Saphirglas", desc: "Kratzfestes Saphirglas mit Anti-Reflex-Beschichtung." },
        { title: "Wasserdicht", desc: "Zuverlässig bis 10 ATM — bereit für jedes Abenteuer." },
      ],
    },
    configurator: {
      kicker: "DEIN ZEITMESSER",
      title: "Konfiguriere deine Uhr",
      subtitle: "Wähle jedes Detail. Live-Vorschau. Sofort dein Preis.",
      case: "Gehäuse",
      dial: "Zifferblatt",
      hands: "Zeiger",
      strap: "Armband",
      result: "Ergebnis",
      engraving: "Gravur",
      engravingPlaceholder: "z.B. Deine Initialen (max 20 Zeichen)",
      addToCart: "In den Warenkorb",
      save: "Konfiguration speichern",
      share: "Teilen",
      price: "Preis",
      summary: "Deine Auswahl",
      material: "Material",
      free: "Inklusive",
    },
    collection: {
      kicker: "AKTUELLE KOLLEKTION",
      title: "Sechs Charaktere, ein Ursprung",
      subtitle: "Von der klassischen Alpine bis zum limitierten Eiger Emerald.",
      view: "Konfigurieren",
    },
    story: {
      kicker: "UNSERE GESCHICHTE",
      title: "Aus Leidenschaft für den Zeitmesser",
      p1: "SOMMET ZÜRICH ist eine junge Schweizer Marke mit einer klaren Idee: Uhren, die aussehen wie Luxus – ohne den Aufschlag für den Namen. Wir arbeiten direkt mit Manufakturen, verzichten auf teure Zwischenhändler und geben diesen Vorteil an dich weiter. So bekommst du eine Uhr, die technisch mit Modellen für das Zehnfache mithält.",
      p2: "Was uns anders macht: du entwirfst deine Uhr selbst. Gehäuse, Zifferblatt, Zeiger, Armband, Gravur – jede SOMMET verlässt unser Atelier als Unikat, verpackt in einer hochwertigen Box, geprüft und bereit für ein Leben an deinem Handgelenk. 30 Tage Rückgaberecht, 24 Monate Garantie, weltweiter Versand.",
      stat1Label: "Gegründet",
      stat1Value: "2026",
      stat2Label: "Komponenten pro Uhr",
      stat2Value: "138",
      stat3Label: "Garantie",
      stat3Value: "24 M.",
    },
    quality: {
      kicker: "SCHWEIZER QUALITÄT",
      title: "Kompromisslos. In jedem Detail.",
      items: [
        { title: "316L Edelstahl", desc: "Chirurgische Legierung, korrosionsfrei und hypoallergen." },
        { title: "Schweizer Werk", desc: "Mechanisches Automatikwerk mit 42h Gangreserve." },
        { title: "Handmontage", desc: "Jedes Stück wird in Zürich einzeln montiert und geprüft." },
      ],
    },
    reviews: {
      kicker: "KUNDENSTIMMEN",
      title: "Was unsere Kunden sagen",
      items: [
        { name: "Andreas M.", city: "Zürich", text: "Meine SOMMET fühlt sich wirklich wie meine an. Der Konfigurator ist ein Erlebnis für sich." },
        { name: "Sophie L.", city: "Genf", text: "Die Verarbeitung ist auf Augenhöhe mit Marken jenseits von 3000 CHF. Absolut empfehlenswert." },
        { name: "Marco R.", city: "Bern", text: "Ich trage sie täglich. Nach 6 Monaten sieht sie noch aus wie am ersten Tag." },
      ],
    },
    faq: {
      kicker: "FAQ",
      title: "Häufig gestellte Fragen",
      items: [
        { q: "Wie lange dauert die Fertigung meiner individuellen Uhr?", a: "In der Regel 3–4 Wochen. Wir montieren jedes Stück von Hand in unserer Zürcher Manufaktur." },
        { q: "Ist wirklich jede Uhr wasserdicht bis 10 ATM?", a: "Ja, jedes Gehäuse wird nach ISO 22810 individuell druckgetestet. Duschen ist problemlos möglich. Beim Schwimmen achte bitte darauf, dass die Krone und alle Schrauben fest zugedreht sind." },
        { q: "Kann ich meine Konfiguration später ändern?", a: "Vor Produktionsstart selbstverständlich. Danach garantieren wir die exakte Umsetzung deines Designs." },
        { q: "Wie sieht der Versand aus?", a: "Kostenloser Versicherter Versand in der Schweiz. Weltweit ab CHF 25." },
        { q: "Welche Garantie erhalte ich?", a: "2 Jahre internationale SOMMET-Garantie auf Uhrwerk und Verarbeitung." },
      ],
    },
    newsletter: {
      kicker: "BLEIBE VERBUNDEN",
      title: "Neue Kollektionen zuerst.",
      subtitle: "Erhalte exklusive Vorschauen und limitierte Editionen.",
      placeholder: "Deine E-Mail-Adresse",
      cta: "Anmelden",
      success: "Willkommen bei SOMMET ZÜRICH.",
    },
    contact: {
      kicker: "KONTAKT",
      title: "Sprich mit uns",
      subtitle: "Fragen zur Konfiguration oder deiner Uhr? Wir sind hier.",
      name: "Name",
      email: "E-Mail",
      subject: "Betreff",
      message: "Nachricht",
      send: "Nachricht senden",
      address: "Bahnhofstrasse 42, 8001 Zürich, Schweiz",
      hours: "Mo–Fr 09:00 – 18:00",
      phone: "+41 76 702 17 77",
      emailAddress: "sommetuhrenwerke@gmail.com",
      whatsappNumber: "+41 76 702 17 77",
      whatsappCta: "Chat auf WhatsApp öffnen",
    },
    footer: {
      tagline: "Swiss Made. Your Design.",
      shop: "Shop",
      brand: "Marke",
      support: "Support",
      legal: "Rechtliches",
      links: {
        collection: "Kollektion",
        configurator: "Konfigurator",
        gift: "Geschenkgutschein",
        about: "Über uns",
        story: "Geschichte",
        press: "Presse",
        contact: "Kontakt",
        shipping: "Versand",
        returns: "Rückgabe",
        imprint: "Impressum",
        privacy: "Datenschutz",
        terms: "AGB",
      },
      copyright: "© 2026 SOMMET ZÜRICH AG. Alle Rechte vorbehalten.",
    },
    cart: {
      title: "Warenkorb",
      empty: "Dein Warenkorb ist leer.",
      startConfig: "Konfiguriere deine Uhr",
      subtotal: "Zwischensumme",
      shipping: "Versand",
      free: "Kostenlos",
      total: "Gesamt",
      checkout: "Zur Kasse",
      remove: "Entfernen",
      customized: "Individuell konfiguriert",
      close: "Schließen",
    },
    checkout: {
      title: "Kasse",
      customerInfo: "Kundendaten",
      fullName: "Vollständiger Name",
      email: "E-Mail",
      address: "Lieferadresse",
      placeOrder: "Bestellung aufgeben",
      paymentTitle: "Zahlungsmethode",
      paymentNotice: "Die Zahlung wird nach Bestellbestätigung über WhatsApp oder E-Mail abgewickelt.",
      paymentMethods: { card: "Kreditkarte", twint: "TWINT", paypal: "PayPal", bank: "Banküberweisung" },
      feeNotice: "Bei manchen Zahlungsarten können zusätzliche Gebühren des Anbieters anfallen. Diese trägt der Käufer.",
      orderPlaced: "Bestellung erfolgreich!",
      orderNumber: "Bestellnummer",
      thankYou: "Danke für dein Vertrauen in SOMMET ZÜRICH.",
      backHome: "Zurück zur Startseite",
    },
  },
  en: {
    nav: {
      home: "Home",
      collection: "Collection",
      configurator: "Configure",
      about: "About us",
      contact: "Contact",
    },
    hero: {
      kicker: "SWISS MADE. YOUR DESIGN.",
      title: "BUILD YOUR SOMMET",
      subtitle: "Design your personal SOMMET timepiece. Choose every detail and create a watch that is truly yours.",
      cta: "Start configuring",
      cta2: "Discover collection",
    },
    advantages: {
      kicker: "WHY SOMMET",
      title: "Precision from Zurich",
      items: [
        { title: "Custom made", desc: "Designed by you — built by our Swiss atelier, one at a time." },
        { title: "Premium quality", desc: "316L stainless steel case, CNC-machined and hand-polished." },
        { title: "Sapphire crystal", desc: "Scratch-resistant crystal with anti-reflective coating." },
        { title: "Water resistant", desc: "Reliable up to 10 ATM — ready for every adventure." },
      ],
    },
    configurator: {
      kicker: "YOUR TIMEPIECE",
      title: "Configure your watch",
      subtitle: "Choose every detail. Live preview. Instant price.",
      case: "Case",
      dial: "Dial",
      hands: "Hands",
      strap: "Strap",
      result: "Result",
      engraving: "Engraving",
      engravingPlaceholder: "e.g. Your initials (max 20 characters)",
      addToCart: "Add to cart",
      save: "Save configuration",
      share: "Share",
      price: "Price",
      summary: "Your selection",
      material: "Material",
      free: "Included",
    },
    collection: {
      kicker: "CURRENT COLLECTION",
      title: "Six characters, one origin",
      subtitle: "From the classic Alpine to the limited Eiger Emerald.",
      view: "Configure",
    },
    story: {
      kicker: "OUR STORY",
      title: "Made with love for the timepiece",
      p1: "SOMMET ZÜRICH is a young Swiss brand with a clear idea: watches that look like luxury – without paying for the name. We work directly with manufacturers, skip expensive middlemen and pass the savings on to you. What you get is a watch that technically holds its own against models ten times the price.",
      p2: "What makes us different: you design your own. Case, dial, hands, strap, engraving – every SOMMET leaves our atelier as a one-of-one piece, in a premium box, tested and ready for a lifetime on your wrist. 30-day returns, 24 months warranty, worldwide shipping.",
      stat1Label: "Founded",
      stat1Value: "2026",
      stat2Label: "Components per watch",
      stat2Value: "138",
      stat3Label: "Warranty",
      stat3Value: "24 mo.",
    },
    quality: {
      kicker: "SWISS QUALITY",
      title: "Uncompromising. In every detail.",
      items: [
        { title: "316L stainless steel", desc: "Surgical alloy, corrosion-free and hypoallergenic." },
        { title: "Swiss movement", desc: "Mechanical automatic with 42h power reserve." },
        { title: "Hand assembly", desc: "Each piece assembled and tested in Zurich, individually." },
      ],
    },
    reviews: {
      kicker: "CUSTOMER STORIES",
      title: "What our clients say",
      items: [
        { name: "Andreas M.", city: "Zurich", text: "My SOMMET truly feels like mine. The configurator is an experience in itself." },
        { name: "Sophie L.", city: "Geneva", text: "Craft on par with brands beyond 3000 CHF. Absolutely recommended." },
        { name: "Marco R.", city: "Bern", text: "I wear it daily. After 6 months, it looks like day one." },
      ],
    },
    faq: {
      kicker: "FAQ",
      title: "Frequently asked questions",
      items: [
        { q: "How long does production of my custom watch take?", a: "Usually 3–4 weeks. We assemble every piece by hand in our Zurich atelier." },
        { q: "Are all watches truly water resistant to 10 ATM?", a: "Yes, every case is pressure-tested individually according to ISO 22810. Showering is no problem. When swimming, please make sure the crown and all screws are firmly tightened." },
        { q: "Can I change my configuration later?", a: "Before production starts, of course. Afterwards we guarantee the exact realization of your design." },
        { q: "How does shipping work?", a: "Free insured shipping within Switzerland. Worldwide from CHF 25." },
        { q: "What warranty do I get?", a: "2 years international SOMMET warranty on movement and craftsmanship." },
      ],
    },
    newsletter: {
      kicker: "STAY CONNECTED",
      title: "New collections, first.",
      subtitle: "Get exclusive previews and limited editions.",
      placeholder: "Your email address",
      cta: "Subscribe",
      success: "Welcome to SOMMET ZÜRICH.",
    },
    contact: {
      kicker: "CONTACT",
      title: "Talk to us",
      subtitle: "Questions about your configuration or watch? We're here.",
      name: "Name",
      email: "Email",
      subject: "Subject",
      message: "Message",
      send: "Send message",
      address: "Bahnhofstrasse 42, 8001 Zurich, Switzerland",
      hours: "Mon–Fri 09:00 – 18:00",
      phone: "+41 76 702 17 77",
      emailAddress: "sommetuhrenwerke@gmail.com",
      whatsappNumber: "+41 76 702 17 77",
      whatsappCta: "Open WhatsApp chat",
    },
    footer: {
      tagline: "Swiss Made. Your Design.",
      shop: "Shop",
      brand: "Brand",
      support: "Support",
      legal: "Legal",
      links: {
        collection: "Collection",
        configurator: "Configurator",
        gift: "Gift card",
        about: "About us",
        story: "Story",
        press: "Press",
        contact: "Contact",
        shipping: "Shipping",
        returns: "Returns",
        imprint: "Imprint",
        privacy: "Privacy",
        terms: "Terms",
      },
      copyright: "© 2026 SOMMET ZÜRICH AG. All rights reserved.",
    },
    cart: {
      title: "Cart",
      empty: "Your cart is empty.",
      startConfig: "Configure your watch",
      subtotal: "Subtotal",
      shipping: "Shipping",
      free: "Free",
      total: "Total",
      checkout: "Checkout",
      remove: "Remove",
      customized: "Custom configuration",
      close: "Close",
    },
    checkout: {
      title: "Checkout",
      customerInfo: "Customer information",
      fullName: "Full name",
      email: "Email",
      address: "Shipping address",
      placeOrder: "Place order",
      paymentTitle: "Payment method",
      paymentNotice: "Payment is arranged after order confirmation via WhatsApp or email.",
      paymentMethods: { card: "Credit card", twint: "TWINT", paypal: "PayPal", bank: "Bank transfer" },
      feeNotice: "Some payment methods may carry additional provider fees. These are paid by the buyer.",
      orderPlaced: "Order placed successfully!",
      orderNumber: "Order number",
      thankYou: "Thank you for trusting SOMMET ZÜRICH.",
      backHome: "Back to homepage",
    },
  },
};
